export class AddLicenseModel {
  serial = ''
}

export enum LicenseType {
  SerialNumber = 1,
  LicenseNumber = 2,
}

export enum LicenseCreationModes {
  ManualSelect = 1,
  ByDeviceSerialNumber = 2,
}
